import http, { FetchFrom } from '../http'
import { Res } from '../type'

export const getShareCode = (params: any) => {
  return FetchFrom('other.promo', params)
}

export const getCityArea = (): Res<any> => {
  return http.request({
    url: '/api/other/findProCityArea.do',
    method: 'post',
    loadingShow: '0'
  })
}
